"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const UFC_ENDPOINT = '/flag-config/v1/config';
class FlagConfigurationRequestor {
    constructor(configurationStore, httpClient) {
        this.configurationStore = configurationStore;
        this.httpClient = httpClient;
    }
    async fetchAndStoreConfigurations() {
        const responseData = await this.httpClient.get(UFC_ENDPOINT);
        if (!responseData) {
            return {};
        }
        this.configurationStore.setEntries(responseData.flags);
        return responseData.flags;
    }
}
exports.default = FlagConfigurationRequestor;
//# sourceMappingURL=flag-configuration-requestor.js.map